import React from 'react';

import LinkButton from '@core/components/linkbutton/LinkButton';

import classes from './B2BOffer.module.scss';


const B2B_MAIL_LINK = 'mailto:info@pharmuni.com?subject=Regarding%20B2B%20offer';

const B2BOffer = () => {
    return (
        <div className='container'>
            <div className={classes['b2b-offer']}>
                <div className='row align-items-center'>
                    <div className='col-lg-8 col-12'>
                        <h3>Plans for Teams &amp; Organizations</h3>
                        <p>
                            Need Pharmuni access for your company, university, institution, or organization? Contact us
                            for a <strong>special team offer</strong>, flexible group enrollment, and{' '}
                            <strong>one aggregated payment via invoice.</strong>
                        </p>
                        <p className='mb-0'>
                            We support companies, universities, government institutions, training organizations, and
                            other professional teams.
                        </p>
                    </div>
                    <div className='col-lg-4 col-12'>
                        <div className={classes['actions']}>
                            <LinkButton kind='secondary-lecture' className={classes['cta']} href={B2B_MAIL_LINK}>
                                Get a Team Offer
                            </LinkButton>
                            <a className={classes['mail-link']} href={B2B_MAIL_LINK}>
                                Email us at info@pharmuni.com
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default B2BOffer;
